import { MenuEntry } from '@mozartfinance/uikit'

const config: MenuEntry[] = [
  // {
  //   label: 'Home',
  //   icon: 'HomeIcon',
  //   href: '',
  // },
  // {
  //   label: 'Trade',
  //   icon: 'TradeIcon',
  //   items: [
  //     {
  //       label: 'Exchange',
  //       href: '/swap',
  //     },
  //     {
  //       label: 'Liquidity',
  //       href: '/pool',
  //     },
  //   ],
  // },
  // {
  //   label: 'Farms',
  //   icon: 'FarmIcon',
  //   href: '',
  // },
  // {
  //   label: 'Pools',
  //   icon: 'PoolIcon',
  //   href: '',
  // },
  // {
  //   label: 'More',
  //   icon: 'MoreIcon',
  //   items: [
  //     {
  //       label: 'Github',
  //       href: '',
  //     },
  //     {
  //       label: 'Docs',
  //       href: '',
  //     },
  //     {
  //       label: 'Blog',
  //       href: '',
  //     },
  //   ],
  // },

  // {
  //   label: 'Log Out',
  //   icon: 'TicketIcon',
  //   href: '/logout',
  // },
]

export default config
